import { j as h } from "./jsx-runtime.js";
import { useRef as D, useEffect as a, useState as j } from "react";
import { Metapage as y, MetapageEvents as b } from "@metapages/metapage";
const C = ({ metaframe: t, Wrapper: c, style: u = { height: "100%" }, className: s, classNameWrapper: m }) => {
  const e = D(null);
  return a(() => {
    let l = !1;
    if (t && !t.isDisposed())
      return (async () => {
        if (t.isDisposed() || l)
          return;
        const r = await t.iframe;
        if (!t.isDisposed() && !l && e != null && e.current && (!e.current.firstChild || e.current.firstChild !== r)) {
          const d = e.current.firstChild;
          d && e.current.removeChild(d), s == null || s.split(" ").forEach((g) => r.classList.add(g)), s || (r.style.cssText = "overflow:clip;width:100%;height:100%;maxHeight:100%;left:0;position:absolute;top:0;"), e.current.appendChild(r);
        }
      })(), () => {
        var r;
        for (l = !0; (r = e == null ? void 0 : e.current) != null && r.firstChild; )
          e.current.removeChild(e.current.firstChild);
      };
  }, [t, e]), t ? c ? h.jsx(c, { ref: e }, t.id) : h.jsx("div", { ref: e, className: m, style: {
    overflow: "clip",
    width: "100%",
    position: "relative",
    ...u
  } }, t.id) : h.jsx("p", { children: "Missing metaframe" });
}, p = "embed", E = {
  version: "1",
  metaframes: {
    [p]: {
      url: ""
    }
  }
}, S = ({ url: t, inputs: c, onOutputs: u, onMetapageCreation: s, debug: m, style: e, className: l, classNameWrapper: r, onUrlChange: d }) => {
  const [g, x] = j(), [i, v] = j();
  return a(() => {
    const o = [], n = Object.assign({}, { ...E });
    n.metaframes.embed.url = t;
    const f = new y();
    f.debug = m;
    let M = !1;
    return (async () => (await f.setDefinition(n), !M && (v(f), s && s(f))))(), () => {
      for (M = !0, f.dispose(); o.length > 0; ) {
        const w = o.pop();
        w && w();
      }
    };
  }, [t, s, m]), a(() => {
    if (!i || !p || !x)
      return;
    const o = i.getMetaframe(p);
    x(o);
    let n;
    return u && (n = o.onOutputs((f) => {
      u(f);
    })), () => {
      n && n();
    };
  }, [i, x, p, u]), a(() => {
    if (!(!i || !d))
      return i.addListenerReturnDisposer(b.Definition, (o) => {
        const n = o.definition.metaframes[p];
        d(n.url);
      });
  }, [i, d]), a(() => {
    i && !i.isDisposed() && c && i.setInputs({
      embed: c
    });
  }, [i, c]), g ? h.jsx(C, { metaframe: g, style: e || { height: "100%" }, className: l, classNameWrapper: r }) : h.jsx("p", { children: "..." });
};
export {
  C as M,
  S as a
};
//# sourceMappingURL=MetaframeStandaloneComponent.js.map
